<template>
  <panel :title="title">
    <w-input v-if="!decisionWithRanges" :model="$schema.data.amount" />

    <w-textarea :model="$schema.comment" />

    <div class="row">
      <w-datepicker class="col-md-6" :model="$schema.startDate" />

      <w-datepicker class="col-md-6" :model="$schema.endDate" />
    </div>

    <div v-if="decisionWithRanges" class="mt-5">
      <h2>Zakresy dat decyzji</h2>

      <decision-ranges :model="$schema.dateRanges" :types="decisionDatesTypes" :with-amount="decisionWithRanges" />
    </div>

    <decision-data-ranges v-if="stateData.dataDateRanges" :model="$schema.dataDateRanges" />

    <template slot="footer">
      <w-button class="btn-primary float-right" text="Zapisz" icon="fas fa-check" @click="submit" />
    </template>
  </panel>
</template>

<script>
import { mapState } from 'vuex';

import Panel from '@/components/panel/Panel';
import { DecisionCalculationType, DecisionCalculationTypeTranslation } from '@/enums/decisionCalculationType';
import { PublicSettings } from '@/enums/publicSettings.enum';
import { Successes } from '@/enums/successes.enum';
import { editMixin } from '@/mixins/edit';
import schema from '@/schemas/decision.schema';

import DecisionDataRanges from './DecisionDataRanges';
import DecisionRanges from './DecisionRanges';

// @vuese
// Formularz pojedynczej decyzji
// @group Decistion
export default {
  components: { DecisionRanges, DecisionDataRanges, Panel },
  mixins: [editMixin('decision')],
  schema,
  data() {
    return {
      decisionDatesTypes: [
        { value: DecisionCalculationType.AMOUNT, text: DecisionCalculationTypeTranslation.AMOUNT },
        { value: DecisionCalculationType.INVOICE, text: DecisionCalculationTypeTranslation.INVOICE },
        { value: DecisionCalculationType.HOLD, text: DecisionCalculationTypeTranslation.HOLD },
        { value: DecisionCalculationType.WITHDRAWAL, text: DecisionCalculationTypeTranslation.WITHDRAWAL }
      ]
    };
  },
  computed: {
    ...mapState({
      stateData: state => state.documentIndex.data.currentDecision,
      decisionWithRanges: state => state.setting.settings[PublicSettings.DECISION_WITH_RANGES]?.value === 'true'
    }),
    id() {
      return this.stateData.id;
    },
    title() {
      return this.stateData.name + ' ' + this.stateData.number;
    }
  },
  methods: {
    // @vuese
    // Wyświetla notyfikację o zapisie decyzji
    afterSave(id) {
      this.notifySuccess(Successes.DECISION_SAVED);
    }
  }
};
</script>
